<script setup lang="ts">
/**
 * Group table cell: business service types linked to the group, rendered
 * as pill tags — mirrors the sketch's `.svcs`/`.svc` (green pill). Uses
 * the app's own success-surface tokens rather than inventing new ones.
 */
defineProps<{
  /** Resolved service-type labels; empty renders an en dash, matching every
   * other cell's `emptyPlaceholder` convention (e.g. `TextCell`). */
  labels: string[]
  /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
  maxWidth?: string
}>()
</script>

<template>
  <td
    class="font-tufte-sans"
    :style="{
      fontSize: 'var(--text-tufte-xs)',
      ...(maxWidth ? { maxWidth, overflowWrap: 'break-word' } : {}),
    }"
  >
    <div v-if="labels.length" class="group-service-types-cell__list">
      <span v-for="label in labels" :key="label" class="group-service-types-cell__pill">{{
        label
      }}</span>
    </div>
    <span v-else class="text-tufte-muted">–</span>
  </td>
</template>

<style scoped>
.group-service-types-cell__list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem 0.3rem;
}

.group-service-types-cell__pill {
  background: var(--color-surface-success);
  color: var(--color-tufte-success);
  padding: 0.05rem 0.4rem;
  border-radius: 2px;
  overflow-wrap: anywhere;
}
</style>
